import React from 'react'

import PropTypes from 'prop-types'
import { useMediaQuery, usePopup } from '@deseretbook/react-utils'
import { Box, Button, Modal, useTheme, Drawer } from '@deseretbook/react-ui'
import PlusCircle from '@deseretbook/icons/react/plus-circle'
import { SignupModal } from '../../../subscriptions'

/**
 * Lists available options for the product.
 * Everything from watch, view trailer, and purchase options
 *
 * @returns {function} React Component
 */
export const Options = ({
  user = {},
  trailer = {},
  video = {},
  activatePlayer,
  physicalVariants = [],
}) => {
  const theme = useTheme()
  const currentDate = new Date().toISOString().slice(0, 10)
  const isDeseretVideoSubscriber =
    user &&
    !!user.subscriptions.filter(
      ({ subscriptionPlan, awaitingCompletion, serviceableUntil, status }) =>
        !awaitingCompletion &&
        (serviceableUntil >= currentDate || status === 'Active') &&
        subscriptionPlan &&
        subscriptionPlan.type === 'SubscriptionPlan::DeseretVideo',
    ).length

  const [hasDeseretVideo, setHasDeseretVideo] = React.useState(isDeseretVideoSubscriber)
  // For when the content reaches its tablet breakpoint
  const isTabletOrSmaller = useMediaQuery({ maxWidth: 767 })
  const moreOptionsModal = usePopup()
  const moreOptionsDrawer = usePopup()
  const signupModal = usePopup()

  const hasPlusModal = !isDeseretVideoSubscriber

  return (
    <React.Fragment>
      {hasPlusModal && (
        <SignupModal
          popupProps={signupModal.popupProps}
          user={user}
          onClose={signupModal.close}
          onSuccess={() => {
            setHasDeseretVideo(true)
          }}
          documentUID="product-deseret-video"
          documentType="subscription_signup_v1"
        />
      )}

      <Box paddingRight={isTabletOrSmaller ? 0 : 1}>
        {hasDeseretVideo ? (
          <Button
            isFullwidth={isTabletOrSmaller}
            type="button"
            icon="play"
            color="video"
            onClick={() => {
              activatePlayer(video.url)
            }}
          >
            Watch Now
          </Button>
        ) : (
          <Button
            isFullwidth={isTabletOrSmaller}
            type="button"
            color="primary"
            onClick={() => {
              activatePlayer(video.url)
            }}
            {...signupModal.triggerProps}
          >
            Watch with Deseret Video
          </Button>
        )}
      </Box>
      {trailer && trailer.url && (
        <Box paddingRight={isTabletOrSmaller ? 0 : 1}>
          <Button
            isFullwidth={isTabletOrSmaller}
            type="button"
            icon="play"
            onClick={() => {
              activatePlayer(trailer.url)
            }}
          >
            Watch Trailer
          </Button>
        </Box>
      )}
      {/*  PURCHASE OPTIONS */}
      {physicalVariants && isTabletOrSmaller ? (
        <React.Fragment>
          <Box paddingTop={1}>
            <Button isFullwidth type="button" {...moreOptionsDrawer.triggerProps}>
              More Purchase Options
            </Button>
          </Box>

          {/* More Options Drawer */}
          <Drawer {...moreOptionsDrawer.popupProps} position="bottom">
            <Drawer.Content>
              <Button isFullwidth type="button">
                DVD $14.99
              </Button>
              <Button isFullwidth type="button">
                Blu-Ray $14.99
              </Button>
            </Drawer.Content>
            <Drawer.Footer>
              <Button isFullwidth type="button">
                Add to Cart
              </Button>
            </Drawer.Footer>
          </Drawer>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Box paddingRight={1}>
            <Button type="button" {...moreOptionsModal.triggerProps}>
              More Purchase Options
            </Button>
            {/* More Options Modal */}
            <Modal {...moreOptionsModal.popupProps} position="bottom">
              <Modal.Content>
                <Button isFullwidth type="button">
                  DVD $14.99
                </Button>
                <Button isFullwidth type="button">
                  Blu-Ray $14.99
                </Button>
              </Modal.Content>
              <Modal.Footer>
                <Button isFullwidth type="button">
                  Add to Cart
                </Button>
              </Modal.Footer>
            </Modal>
          </Box>
          <Box paddingRight={1} alignItems="center">
            <PlusCircle width="2.5rem" height="2.5rem" color={theme.palette.light.dark} />
          </Box>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

Options.propTypes = {
  trailer: PropTypes.shape({
    url: PropTypes.string,
  }),
  video: PropTypes.shape({
    url: PropTypes.string,
  }),
  activatePlayer: PropTypes.func,
  user: PropTypes.shape(PropTypes.any),
  physicalVariants: PropTypes.arrayOf(PropTypes.object),
}
